module.exports = __webpack_public_path__ + "static/media/intro.34fbaf44.png";